import axios from "axios";
import { publishRecruitingNextActions } from "./recruitingNextActions";
import { installRecordChangeListeners, recordsChanged } from "./recordChanges";

export function isRecordMutation(url, method = "GET", apiBase = process.env.REACT_APP_API_BASE || "") {
  if (!["POST", "PUT", "PATCH", "DELETE"].includes(String(method).toUpperCase())) return false;
  try {
    const base = new URL(apiBase || "/", window.location.origin);
    const target = new URL(url, window.location.origin);
    if (target.origin !== base.origin) return false;
    let path = target.pathname;
    const prefix = base.pathname.replace(/\/$/, "");
    if (prefix && path.startsWith(`${prefix}/`)) path = path.slice(prefix.length);
    path = path.replace(/^\/api(?=\/)/, "");
    return /^\/(candidates|candidate-stages|jobs|leads|companies|hiring-managers|contacts|activities|sequences|calendar)(\/|$)/.test(path);
  } catch { return false; }
}

export function installRecordSync() {
  if (window.__rpoRecordSyncInstalled) return;
  window.__rpoRecordSyncInstalled = true;
  installRecordChangeListeners();
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);
    const url = typeof input === "string" || input instanceof URL ? String(input) : input.url;
    const method = init?.method || input?.method || "GET";
    if (response.ok && isRecordMutation(url, method)) {
      recordsChanged();
      if (response.clone) {
        try { publishRecruitingNextActions(await response.clone().json()); } catch {}
      }
    }
    return response;
  };
  axios.interceptors.response.use(response => {
    const url = axios.getUri(response.config);
    if (response.status >= 200 && response.status < 300 && isRecordMutation(url, response.config.method)) {
      recordsChanged();
      publishRecruitingNextActions(response.data);
    }
    return response;
  });
}
